<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
// import '../static/libs/lib'
// import '../static/libs/common'
// import '../static/libs/DPlayer.min'
// import '../static/libs/index'
// if (window.location.search !== "") {
//       console.log(window.location.search.split('?')[1].split('=')[1]);
//       import ('../static/tinymce/' + window.location.search.split('?')[1].split('=')[1] +'/app.css')
// } else {
//   import ('./assets/css/app.css')
// }

export default {
  name: 'App',
   provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
    /* @import url("./assets/css/app.css"); */
  
</style>



// WEBPACK FOOTER //
// src/App.vue